import { Container, Eyebrow, Section, Reveal } from "./common";
import { NODO_SERRANO } from "../data/content";

export const NodoSerrano = () => {
  return (
    <Section id="nodo-serrano" alt>
      <Container>
        <Reveal>
          <Eyebrow>En marcha · No es una hipótesis</Eyebrow>
          <h2 className="mt-5 font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-100">
            El NODO Serrano ya está <span className="text-rc-sage italic">en pre-ensamblaje</span>
          </h2>
          <p className="mt-6 max-w-2xl text-stone-400 font-light leading-relaxed">
            La arquitectura no está solo escrita: ya se construye en territorio. Estos son los avances
            reales, hoy.
          </p>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 gap-6 lg:gap-8">
          {NODO_SERRANO.map((n, i) => (
            <Reveal key={n.title} delay={i * 0.08}>
              <div className="h-full p-8 rounded-2xl bg-rc-card border border-rc-border hover:border-rc-sage/40 transition-all duration-300">
                <span className="inline-block text-xs font-mono px-3 py-1 rounded-full bg-rc-forest/25 text-rc-sage border border-rc-forest/40">
                  {n.estado}
                </span>
                <h3 className="mt-5 font-serif text-xl text-stone-100">{n.title}</h3>
                <p className="mt-3 text-stone-400 font-light leading-relaxed">{n.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-12 max-w-3xl font-serif text-lg sm:text-xl font-light leading-relaxed text-stone-300 border-l-2 border-rc-terra/60 pl-6">
            Lo que falta no es voluntad ni territorio. Es la{" "}
            <span className="text-rc-sand italic">pieza jurídica final</span> — y espera, a propósito, a que
            el marco normativo de 2026 se defina para ensamblarse de una vez y para siempre.
          </p>
        </Reveal>
      </Container>
    </Section>
  );
};
